import { ComputedRef, InjectionKey } from 'vue';

type DarkInjectionDataType = {
    isDark?: ComputedRef<boolean>
};

export const DarkInjectionKey = Symbol() as InjectionKey<DarkInjectionDataType>;
